import React from 'react';

const ShopifyIcon = ({ style = {}, className = '' }) => {
  const defaultStyle = {
    width: '1.3em',
    height: '1.3em',
    verticalAlign: '-0.2em',
    display: 'inline-block',
    ...style
  };

  return (
    <img
      src="/images/shopify.svg"
      alt="Shopify"
      style={defaultStyle}
      className={className}
    />
  );
};

export default ShopifyIcon;
